import { gql } from "@apollo/client";

export const CREATE_EMPLOYEEEMPLOYMENT = gql`
  mutation createEmployeeEmployment($input: createEmployeeEmploymentInput) {
    createEmployeeEmployment(input: $input) {
      employeeId
    }
  }
`;

export const UPDATE_EMPLOYEEEEMPLOYMENT = gql`
  mutation UpdateEmployeeEmployment($input: updateEmployeeEmploymentInput) {
    updateEmployeeEmployment(input: $input)
  }
`;

export const DELETE_EMPLOYEEEMPLOYMENT = gql`
  mutation deleteEmployeeEmployment($Id: Int!) {
    deleteEmployeeEmployment(Id: $Id)
  }
`;

export const GET_EMPLOYEEEMPLOYMENT = gql`
  query EmployeeEmployments($employeeId: String!) {
    employeeEmployments(employeeId: $employeeId) {
      Id
      employeeId
      experienceLetter
      isRecent
      offerLetter
      paySlips
      relieveingLetter
      previousCompany
    }
  }
`;
